var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_1299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63374 1.4728H3.53552C3.58954 1.4728 3.63374 1.4286 3.63374 1.37458V1.4728H7.36588V1.37458C7.36588 1.4286 7.41008 1.4728 7.4641 1.4728H7.36588V2.35672H8.24981V1.37458C8.24981 0.941211 7.89747 0.588867 7.4641 0.588867H3.53552C3.10215 0.588867 2.74981 0.941211 2.74981 1.37458V2.35672H3.63374V1.4728ZM9.82124 2.35672H1.17838C0.961081 2.35672 0.785522 2.53228 0.785522 2.74958V3.14244C0.785522 3.19646 0.829719 3.24065 0.883737 3.24065H1.62525L1.92849 9.66141C1.94813 10.0801 2.29434 10.4103 2.71298 10.4103H8.28664C8.70651 10.4103 9.05148 10.0813 9.07113 9.66141L9.37436 3.24065H10.1159C10.1699 3.24065 10.2141 3.19646 10.2141 3.14244V2.74958C10.2141 2.53228 10.0385 2.35672 9.82124 2.35672ZM8.19211 9.52637H2.80751L2.51041 3.24065H8.48921L8.19211 9.52637Z",
    fill: "#433F5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_1299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlined);
export default __webpack_public_path__ + "static/media/DeleteOutlined.92b1596460097befb6eb24f456aeaf3a.svg";
export { ForwardRef as ReactComponent };